/**
 * Dialog Object: This object creates and manipulates the DOM for roles in the View.
 * It is currently in use for admin/hierarchy.
 * NOTE: all ids should be just the specific purpose of the dialog. Prefix and type will be appended in this object.
 */

date = function() {
	'use strict';

	var objDate = {};

	objDate.convertFromIso = function(dateIso) {
		var s = String(dateIso.substring(0,4)) + '-' + String(dateIso.substring(4,6)) + '-' + String(dateIso.substring(6));
		var d = new Date(s.replace(/-/g, '/').replace(/T/g, ' ').replace(/Z/, ' UTC'));
		var returnDate = (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear() + ' ';
		if (d.getHours() > 12 ) {
			if (d.getMinutes() < 10) {
				returnDate += ( parseInt(d.getHours(), 10) - 12).toString() + ':' + '0' + d.getMinutes() + ' pm';
			} else {
				returnDate += ( parseInt(d.getHours(), 10) - 12).toString() + ':' + d.getMinutes() + ' pm';
			}
		}else if (d.getHours() == 12 ) {
			if (d.getMinutes() < 10) {
				returnDate += d.getHours() + ':' + '0' + d.getMinutes() + ' pm';
			} else {
				returnDate += d.getHours() + ':' + d.getMinutes() + ' pm';
			}
		} else {
			if (d.getMinutes() < 10) {
				returnDate += d.getHours() + ':' + '0' + d.getMinutes() + ' am';
			} else {
				returnDate += d.getHours() + ':' + d.getMinutes() + ' am';
			}
		}

		return returnDate;
	};

	return objDate;
};